// One input grammar for both editors and the server. Blank means unchanged.
export function parseFinancialAmount(value) {
  if (value != null && typeof value !== "string" && typeof value !== "number") throw new Error("Financial amounts must be numbers or formatted USD amounts.");
  if (value == null || String(value).trim() === "") return undefined;
  const raw = String(value).trim().replace(/^(?:USD\s*|\$\s*)/, "");
  if (!/^(?:\d+|\d{1,3}(?:,\d{3})+)(?:\.\d{1,2})?$/.test(raw)) {
    throw new Error("Financial amounts must be non-negative amounts with at most two decimal places.");
  }
  const amount = Number(raw.replaceAll(",", ""));
  if (!Number.isFinite(amount) || amount > 999999999999.99) throw new Error("Financial amount is too large.");
  return amount;
}
export function formatFinancialAmount(value, currency = "USD") {
  if (value == null || value === "") return "";
  return new Intl.NumberFormat("en-US", { style: "currency", currency, maximumFractionDigits: 2 }).format(Number(value));
}
export function monthEnd(month) {
  if (!/^\d{4}-(0[1-9]|1[0-2])$/.test(month || "")) throw new Error("Actuals through must be a valid month.");
  const [year, m] = month.split("-").map(Number);
  if (year < 1900 || year > 9998) throw new Error("Actuals through must be a valid month.");
  return new Date(Date.UTC(year, m, 0)).toISOString().slice(0, 10);
}
export function previousMonthEnd(now = new Date()) {
  return new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), 0)).toISOString().slice(0, 10);
}
export function isActualsStale(date, now = new Date()) {
  if (!date) return false;
  return now.getTime() - new Date(`${date.slice(0, 10)}T00:00:00Z`).getTime() > 45 * 86400000;
}
